<template>
  <breadcrumb :links="{ '/': 'Home', '/radar': 'Radar', 'current': 'Classificazione precipitazioni' }"></breadcrumb>

  <div class="container-xl p-0 py-sm-2 px-sm-3">
    <div id="content_container">
      <div id="sidebar" v-if="showSidebar">
        <a id="close_sidebar" v-on:click="showSidebar = false">
          <i class='bi bi-chevron-double-left'></i>
        </a>
        <h4 class="text-center mt-4">Classificazione</h4>
        <p class="p-4"><strong>HMC- (Hydro Class Map) o Classificazione delle Idrometeore</strong>: grazie
          all’elaborazione dei dati polarimetrici rilevati dal radar di Fossalon di Grado questa mappa fornisce una stima
          dei tipi di idrometeore presenti in atmosfera alla quota più bassa osservabile dal radar stesso.</p>
        <div class="map_legend">
          <Legend :legend="this.legend">
          </Legend>
        </div>
      </div>
      <button class="btn btn-light button" id="close_sidebar" v-on:click="showSidebar = false; showXButton = false"
        v-if="showXButton">
        <i class="bi bi-x-lg p-2"></i>
        <span class="text-color">Classificazione</span>
      </button>
      <div id="map_container">
        <div v-if="!radarAvailable" class="no_radar alert alert-warning alert-dismissible" role="alert">
          <i class="bi bi-exclamation-triangle"></i> {{ radarNotAvailable() }}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <button v-if="!this.showSidebar" id="show_sidebar" class="btn btn-light button"
          v-on:click="showSidebar = true; showXButton = true">
          <i class="bi bi-list p-2"></i>
          <span class="text-color">Legenda</span>
        </button>
        <div class="frame_controls">
          <div class="links" v-if="images && images[current]">
            <a v-for="(image, index) in images" v-bind:key="image.id" :class="index == current ? 'current' : ''"
              v-on:click="current = index"></a>
          </div>
          <div class="info">
            <a :class="'clock' + (radar_time ? ' clock_on' : '')" v-on:click="chooseTime()"></a>
            <a :class="'play_pause' + (animation_id ? ' play_pause_on' : '')" v-on:click="toggleAnimation()"
              v-if="images && images[current]"></a>
            <div class="label" v-if="images && images[current]">
              <span class='time'>{{ convertOnlyTime(images[current].dt).substring(0, 5) }}</span><span class='date'>{{
                convertOnlyDate(images[current].dt) }}</span>
            </div>
          </div>
          <div class="choose_time row justify-content-center" v-if="choose_time_dialog">
            <div class="col-md-2 col-xs-5">
              <input ref="toDateInput" class="form-control" type="date" v-model="inputDate" />
            </div>
            <div class="col-md-2 col-xs-5">
              <input ref="toTimeInput" class="form-control" type="time" v-model="inputTime" />
            </div>
            <div class="col-md-1 col-xs-1">
              <a class="btn btn-primary conditional_btn" v-on:click="setRadarTime(true)" v-if="inputDate && inputTime"><i
                  class="bi bi-check-lg"></i></a>
              <a class="btn btn-secondary conditional_btn" v-on:click="setRadarTime(false)"><i class="bi bi-x-lg"></i></a>
            </div>
          </div>
          <div class="fc_bgd"></div>
        </div>
        <Map class="map" :style="showBands ? '' : 'top: 0; right: 0;'" :data="imageLayers" :current="current"
          :collapsedLegend="true" @view_changed="adapt2View">
        </Map>
      </div>
    </div>
  </div>

  <app-footer-mini></app-footer-mini>
</template>

<script>
import Map from '@/components/Map/BaseFvgMap'
import Legend from '@/components/Legend'
import MonitorApi from '@/services/MonitorApi';
import Labels from '@/utils/labels';
import Breadcrumb from '@/components/Breadcrumb'
import AppFooterMini from '@/app-footer-mini.vue'
import { imageLayers } from '@/components/Map/MapMarkers';
import { ref } from 'vue';

export default {
  components: { Map, Legend, Breadcrumb, AppFooterMini },
  mixins: [Labels],
  data: function () {
    return {
      showSidebar: true,
      legend: {},
      radarAvailable: true,
      images: [],
      imageLayers: [],
      current: 0,
      animation_id: undefined,
      choose_time_dialog: false,
      inputDate: undefined,
      inputTime: undefined,
      radar_time: undefined
    }
  },
  setup() {
    const toDateInput = ref(null);
    const toTimeInput = ref(null);

    return {
      toDateInput,
      toTimeInput,
    };
  },
  methods: {
    toggleSidebar: function () {
      this.showSidebar = !this.showSidebar
    },
    loadImages: async function () {
      const max_time = 129600000; // 36 h
      let to = new Date;
      if (this.radar_time) {
        to = this.radar_time;
      }
      const from = new Date(to - max_time);
      let products;
      products = await MonitorApi.getRadarProducts(1, 'HMC', from, to, 10);
      const images = [];
      const extents = [];
      for (let i in products) {
        const p = products[i];
        const e = p.details.extent
        images.push({
          title: i,
          type: 'image',
          dt: p.dt,
          url: 'https://monitor.protezionecivile.fvg.it/api/products/' + p.id,
          bounds: [[e[1], e[0]], [e[3], e[2]]]
        });
        extents.push({
          bounds: [[e[0], e[3]], [e[2], e[1]]]
        });
        if (i == 0) {
          this.legend = {
            type: 'values',
            title: 'Tipologia',
            values: [
              { label: 'Gocce di grandi dimensioni', color: '#05EB05' },
              { label: 'Pioggia debole', color: '#03A403' },
              { label: 'Pioggia moderata', color: '#FAFA00' },
              { label: 'Pioggia intensa', color: '#FA9600' },
              { label: 'Pioggia e grandine', color: '#FA0000' },
              { label: 'Grandine', color: '#FA0096' },
              { label: 'Graupel/Grandine di piccole dimensioni', color: '#FF80FF' },
              { label: 'Neve asciutta', color: '#3A83F9' },
              { label: 'Nevischio bagnato', color: '#0618E1' },
              { label: 'Cristalli di ghiaccio', color: '#07E6F5' }
            ]
          };
        }
      }
      this.images = images;
      this.imageLayers = imageLayers(images, extents);

    },
    chooseTime() {
      if (this.radar_time == undefined) {
        this.choose_time_dialog = true;
      } else {
        this.radar_time = undefined;
        this.loadImages();
      }
    },
    setRadarTime(set_time) {
      if (set_time) {
        const toDate = this.toDateInput.valueAsDate;
        const toTime = this.toTimeInput.valueAsDate;
        toDate.setHours(toTime.getUTCHours());
        toDate.setMinutes(toTime.getMinutes());
        this.radar_time = toDate;
        this.loadImages();
      }
      this.choose_time_dialog = false;
    },
    toggleAnimation() {
      if (this.animation_id == undefined) {
        const me = this;
        this.animation_id = setInterval(function () {
          if (me.current == 0) {
            me.current = me.images.length - 1;
          }
          else {
            me.current--;
          }
        }, 1000);
      }
      else {
        clearInterval(this.animation_id);
        this.animation_id = undefined;
      }
    },
  },
  mounted: async function () {
    this.showSidebar = false;
    await this.loadImages();
    this.radarAvailable = (this.images.length > 0);
  }

}
</script>

<style lang="scss" scoped>
.text-color {
  padding: 10px;
  writing-mode: vertical-rl;
  text-orientation: sideways-right;
  transform: rotate(180deg);
  color: #0067b1;
}

.button {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 50px;
  height: auto;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

#close_sidebar {
  position: absolute;
  left: 200px;
  z-index: 1011;
  background-color: #fff;
  opacity: 0.8;
  font-variant: small-caps;
  font-weight: bold;
}

#content_container {
  position: relative;
  width: 100%;
  height: 100%;
}

#map_container {
  height: 100%;

  .map {
    height: 100%;
  }
}

#sidebar {
  z-index: 1015;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 200px;
  background-color: #fff;
  opacity: 0.8;
  overflow: auto;

  h4 {
    text-align: right;
    padding: 5px;
  }

  p {
    font-size: 14px;
    padding: 0 5px;
  }
}

#show_sidebar {
  position: absolute;
  top: 10px;
  left: 0;
  z-index: 2000;
  font-variant: small-caps;
  font-weight: bold;
}

.map_legend {
  padding-top: 10px;
  height: 500px;
  font-size: 14px;
}

.no_radar {
  position: absolute;
  top: 160px;
  z-index: 2000;
  left: 20px;
  right: 50px;
}

.frame_controls {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;

  .fc_bgd {
    background-color: #fff;
    opacity: 0.5;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .links {
    position: relative;
    z-index: 2010;
    margin: 0 auto;
    width: 300px;
    overflow: auto;

    a {
      display: block;
      float: right;
      width: 30px;
      height: 30px;
      margin: 0 auto;
      background-image: url(../assets/frame.png);
      background-position-x: 30px;
      cursor: pointer;
    }

    a.current {
      background-position-x: 0;
    }
  }

  .info {
    position: relative;
    z-index: 2010;
    margin: 0 auto;
    color: #0067b1;
    font-size: 20px;
    font-weight: bold;

    .play_pause {
      display: block;
      float: right;
      width: 40px;
      height: 40px;
      margin: 0 auto;
      background-image: url(../assets/play_stop.png);
      background-position-x: 0;
      margin-top: 8px;
    }

    .play_pause_on {
      background-position-x: 40px;
    }

    .clock {
      display: block;
      float: left;
      width: 40px;
      height: 40px;
      margin: 0 auto;
      background-image: url(../assets/clock.png);
      background-position-x: 0;
      margin-top: 8px;
    }

    .clock_on {
      background-position-x: 41px;
    }

    .label {
      span.time {
        display: block;
        text-align: center;
      }

      span.date {
        display: block;
        text-align: center;
        font-size: 0.6em;
      }
    }
  }

  .choose_time {
    position: relative;
    z-index: 2010;
    width: 100%;
    padding: 10px;
  }

  @media (max-width: 768px) {
    .conditional_btn {
      display: block;
      margin: 0 auto;
      width: 50%;
      margin-top: 10px;
    }

    .choose_time {
      position: relative;
      z-index: 2010;
      width: 75%;
      padding: 10px;
    }
  }
}
</style>